import { Row } from 'antd'
import styled from 'styled-components'

export const RNavigatorRow = styled(Row)`
  position: absolute;
  padding: inherit;
  right: 0px;
  bottom: 0px;
`
